/* Zestpics search bar (Claude redesign, Sep 2026; Oct 2026: categories with photos, spelling help, voice search,
   photo tiles, header icon once scrolled). Loaded with defer from snippets/zp-search-bar.liquid. */
(function () {
  var root = document.querySelector('[data-zp-sb]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  var form = root.querySelector('[data-zp-sb-form]');
  var input = root.querySelector('[data-zp-sb-input]');
  var panel = root.querySelector('[data-zp-sb-panel]');
  var idle = root.querySelector('[data-zp-sb-idle]');
  var results = root.querySelector('[data-zp-sb-results]');
  var clearBtn = root.querySelector('[data-zp-sb-clear]');
  var micBtn = root.querySelector('[data-zp-sb-mic]');
  var recentWrap = root.querySelector('[data-zp-sb-recent]');
  var recentList = root.querySelector('[data-zp-sb-recent-list]');
  var tileWrap = root.querySelector('[data-zp-sb-tilewrap]');
  var tileList = root.querySelector('[data-zp-sb-tiles]');
  var searchUrl = root.dataset.searchUrl || '/search';
  var suggestUrl = (root.dataset.suggestUrl || '/search/suggest') + '.json';
  var dataUrl = root.dataset.dataUrl || '/?section_id=zp-search-data';
  var tileNames = (root.dataset.tiles || '').split('|').filter(Boolean);
  var currency = root.dataset.currency || 'INR';
  var fmt;
  try { fmt = new Intl.NumberFormat('en-IN', { style: 'currency', currency: currency, maximumFractionDigits: 0 }); } catch (e) { fmt = null; }
  var timer, ctrl, active = -1, seq = 0, lastFix = null;
  var KEY = 'zp_recent_searches';

  /* ---------- Spelling help & everyday words → the words our products use ---------- */
  var FIX = [
    [/\b(ke+y? ?ch[ae]?i+n+e?s?|kichain|kechain|keychian|keycain|keyring|key ring)\b/g, 'keychain'],
    [/\b(photoframes?|fotoframes?|photo frames)\b/g, 'photo frame'],
    [/\b(farme|frem|frmae|fram|frames)\b/g, 'frame'],
    [/\b(brac?e?l+[ae]?te?s?|braclet|bracelt|bracelate|breslet|brasslet)\b/g, 'bracelet'],
    [/\b(wal+[ae]?t+e?s?|walet|wallat|purse)\b/g, 'wallet'],
    [/\b(cushions?|cusion|pilow|pillo)\b/g, 'pillow'],
    [/\b(water ?bottles?|bottles?|siper|sipper bottle)\b/g, 'sipper'],
    [/\b(name ?board|nameplate|door ?name ?plate|name plat)\b/g, 'name plate'],
    [/\b(cups?|coffee ?mugs?|mag|magic ?cup)\b/g, 'mug'],
    [/\b(cristal|crystel|crystl|chrystal)\b/g, 'crystal'],
    [/\b(callender|calender|calander)\b/g, 'calendar'],
    [/\b(dairy|dairies|diarys)\b/g, 'diary'],
    [/\b(rakhee|rakee|raki|rakhis)\b/g, 'rakhi'],
    [/\b(pendent|lockets?|locket)\b/g, 'pendant'],
    [/\b(magent|magnate|fridge magnet)\b/g, 'magnet'],
    [/\b(clok|clcok|wall clock)\b/g, 'clock'],
    [/\b(puzzel|puzle|jigsaw)\b/g, 'puzzle'],
    [/\b(minature|miniture|figurine)\b/g, 'miniature'],
    [/\b(potrait|portrait|paintng)\b/g, 'painting'],
    [/\b(moonlamp|mon lamp|moon light)\b/g, 'moon lamp'],
    [/\b(led ?light|night ?lamp|nightlamp)\b/g, 'lamp'],
    [/\b(pens|pen stand)\b/g, 'pen'],
    [/\b(passport ?holder|passport ?cover)\b/g, 'passport cover'],
    [/\b(kadaa|kara|karha)\b/g, 'kada'],
    [/\b(annivers[a-z]*|aniversary|anniverssary)\b/g, 'anniversary'],
    [/\b(birth ?day|bday|b'day)\b/g, 'birthday'],
    [/\b(valentines?|valentine's|valantine)\b/g, 'valentine'],
    [/\b(mother|mummy|mum|maa|amma)\b/g, 'mom'],
    [/\b(father|daddy|papa|nanna|appa)\b/g, 'dad'],
    [/\b(personali[sz]ed|customi[sz]ed|custom)\b/g, '']
  ];
  var STOP = /\b(for|gift|gifts|the|a|an|with|my|to|and|of|in|best|unique|online)\b/g;
  function tidyWords(q) { return q.replace(/\s+/g, ' ').trim(); }
  function corrected(q) {
    var s = ' ' + q.toLowerCase() + ' ';
    FIX.forEach(function (f) { s = s.replace(f[0], f[1]); });
    return tidyWords(s);
  }
  function core(q) { return tidyWords(corrected(q).replace(STOP, ' ')); }

  function money(v) {
    if (v === undefined || v === null || v === '') return '';
    var n = typeof v === 'number' ? v : parseFloat(String(v).replace(/[^0-9.]/g, ''));
    if (isNaN(n)) return '';
    if (typeof v === 'number' && n > 10000 && String(v).indexOf('.') === -1) n = n / 100;
    return fmt ? fmt.format(n) : '₹' + Math.round(n);
  }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text) e.textContent = text; return e; }
  function searchLink(q) { return searchUrl + '?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(q); }
  function getRecent() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function saveRecent(q) {
    q = (q || '').trim(); if (!q) return;
    try { var r = getRecent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); }); r.unshift(q); localStorage.setItem(KEY, JSON.stringify(r.slice(0, 6))); } catch (e) {}
  }
  function renderRecent() {
    var r = getRecent();
    recentList.textContent = '';
    if (!r.length) { recentWrap.hidden = true; return; }
    r.forEach(function (q) { var a = el('a', 'zp-sb__chip', q); a.href = searchLink(q); recentList.appendChild(a); });
    recentWrap.hidden = false;
  }
  function open() { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); }
  function close() { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; }
  function showIdle() { results.hidden = true; idle.hidden = false; renderRecent(); loadCats(renderTiles); }
  function highlight(title, q) {
    var frag = document.createDocumentFragment();
    var i = q ? title.toLowerCase().indexOf(q.toLowerCase()) : -1;
    if (i < 0) { frag.appendChild(document.createTextNode(title)); return frag; }
    frag.appendChild(document.createTextNode(title.slice(0, i)));
    frag.appendChild(el('mark', '', title.slice(i, i + q.length)));
    frag.appendChild(document.createTextNode(title.slice(i + q.length)));
    return frag;
  }

  /* ---------- Categories from the menu (loaded once, on first tap) ---------- */
  var cats = null, catsLoading = false, catsWaiting = [];
  function loadCats(cb) {
    if (cats) { cb(cats); return; }
    catsWaiting.push(cb);
    if (catsLoading) return;
    catsLoading = true;
    fetch(dataUrl, { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var m = html.match(/<script type="application\/json" data-zp-search-data>([\s\S]*?)<\/script>/);
        var list = m ? JSON.parse(m[1]) : [];
        var seen = {};
        cats = list.filter(function (c) {
          if (!c.t || !c.u || seen[c.u]) return false;
          seen[c.u] = 1;
          c.imgs = (c.i || '').split('|').filter(Boolean).map(function (s) { var k = s.indexOf('~'); return [s.slice(0, k), s.slice(k + 1)]; });
          c.words = (c.t + ' ' + corrected(c.t)).toLowerCase();
          return true;
        });
      })
      .catch(function () { cats = []; })
      .then(function () { var w = catsWaiting; catsWaiting = []; w.forEach(function (f) { f(cats); }); });
  }
  function photo(c, used) {
    var pick = null;
    for (var i = 0; i < c.imgs.length; i++) { if (!used || !used[c.imgs[i][0]]) { pick = c.imgs[i]; break; } }
    if (!pick && c.imgs.length) pick = c.imgs[0];
    if (!pick) return el('span', 'zp-sb__ph');
    if (used) used[pick[0]] = 1;
    var im = el('img'); im.src = pick[1]; im.alt = ''; im.loading = 'lazy'; im.width = 64; im.height = 64; return im;
  }
  function renderTiles(list) {
    if (!tileList || tileList.childElementCount || !list.length) return;
    var used = {};
    tileNames.forEach(function (name) {
      var c = list.filter(function (x) { return x.t.toLowerCase() === name.toLowerCase(); })[0];
      if (!c) return;
      var a = el('a', 'zp-sb__tile'); a.href = c.u;
      a.appendChild(photo(c, used)); a.appendChild(el('span', '', c.t));
      tileList.appendChild(a);
    });
    tileWrap.hidden = !tileList.childElementCount;
  }
  function matchCats(q) {
    if (!cats) return [];
    var words = core(q).toLowerCase().split(' ').filter(function (w) { return w.length > 1; });
    if (!words.length) return [];
    return cats.filter(function (c) {
      return words.every(function (w) { return new RegExp('(^|[^a-z])' + w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).test(c.words); });
    }).slice(0, 4);
  }

  /* ---------- Results ---------- */
  function render(q, data, shownFor) {
    var res = (data && data.resources && data.resources.results) || {};
    var products = res.products || [], cols = res.collections || [], queries = res.queries || [];
    var catHits = matchCats(q);
    if (!catHits.length && shownFor) catHits = matchCats(shownFor);
    results.textContent = '';
    if (shownFor && products.length) {
      var fix = el('p', 'zp-sb__fix'); fix.appendChild(document.createTextNode('Showing gifts for '));
      fix.appendChild(el('b', '', '“' + shownFor + '”')); results.appendChild(fix);
    }
    if (catHits.length) {
      var gk = el('div', 'zp-sb__group'); gk.appendChild(el('div', 'zp-sb__label', 'Categories'));
      var usedK = {};
      catHits.forEach(function (c) {
        var a = el('a', 'zp-sb__cat'); a.href = c.u; a.setAttribute('role', 'option');
        a.appendChild(photo(c, usedK));
        var t = el('span'); var b = el('b'); b.appendChild(highlight(c.t, (core(q).split(' ')[0] || ''))); t.appendChild(b);
        t.appendChild(el('small', '', c.g + (c.n > 1 ? ' · ' + c.n + ' gifts' : '')));
        a.appendChild(t); gk.appendChild(a);
      });
      results.appendChild(gk);
    }
    if (products.length) {
      var gp = el('div', 'zp-sb__group'); gp.appendChild(el('div', 'zp-sb__label', 'Gifts'));
      products.slice(0, 6).forEach(function (p) {
        var a = el('a', 'zp-sb__prod'); a.href = p.url; a.setAttribute('role', 'option');
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
        if (img) { var im = el('img'); im.src = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120'; im.alt = ''; im.loading = 'lazy'; im.width = 52; im.height = 52; a.appendChild(im); } else { a.appendChild(el('span', 'zp-sb__ph')); }
        var t = el('div'); var tt = el('div', 'zp-sb__pt'); tt.appendChild(highlight(p.title || '', shownFor || q)); t.appendChild(tt);
        var price = money(p.price_min !== undefined ? p.price_min : p.price);
        var cmp = money(p.compare_at_price_min !== undefined ? p.compare_at_price_min : p.compare_at_price_max);
        if (price) { var pp = el('div', 'zp-sb__pp', price); if (cmp && cmp !== price && cmp !== money(0)) { pp.appendChild(el('s', '', cmp)); } t.appendChild(pp); }
        a.appendChild(t); gp.appendChild(a);
      });
      results.appendChild(gp);
    }
    if (queries.length && !shownFor) {
      var g = el('div', 'zp-sb__group'); g.appendChild(el('div', 'zp-sb__label', 'Try searching'));
      var c = el('div', 'zp-sb__chips');
      queries.slice(0, 4).forEach(function (s) { var a = el('a', 'zp-sb__chip', s.text); a.href = searchLink(s.text); c.appendChild(a); });
      g.appendChild(c); results.appendChild(g);
    }
    var known = {}; catHits.forEach(function (c) { known[c.u] = 1; });
    cols = cols.filter(function (col) { return !known[col.url]; });
    if (cols.length && !catHits.length) {
      var gc = el('div', 'zp-sb__group'); gc.appendChild(el('div', 'zp-sb__label', 'Collections'));
      var cc = el('div', 'zp-sb__chips');
      cols.slice(0, 5).forEach(function (col) { var a = el('a', 'zp-sb__chip', col.title); a.href = col.url; cc.appendChild(a); });
      gc.appendChild(cc); results.appendChild(gc);
    }
    if (!products.length && !catHits.length && !cols.length) {
      var e = el('div', 'zp-sb__empty');
      e.appendChild(document.createTextNode('No gifts match “' + q + '” yet. Try a simpler word like “frame”, “mug” or “wallet” — or '));
      var wa = el('a', '', 'ask us on WhatsApp'); wa.href = 'https://wa.me/919676444486?text=' + encodeURIComponent('Hi, I am looking for: ' + q); e.appendChild(wa);
      e.appendChild(document.createTextNode('. We make custom gifts too.'));
      results.appendChild(e);
      loadCats(function (list) {
        if (results.querySelector('.zp-sb__tiles')) return;
        var box = el('div', 'zp-sb__tiles'); var used = {};
        tileNames.slice(0, 8).forEach(function (name) {
          var c = list.filter(function (x) { return x.t.toLowerCase() === name.toLowerCase(); })[0];
          if (!c) return;
          var a = el('a', 'zp-sb__tile'); a.href = c.u; a.appendChild(photo(c, used)); a.appendChild(el('span', '', c.t)); box.appendChild(a);
        });
        if (box.childElementCount) { results.appendChild(el('div', 'zp-sb__label', 'Popular categories')); results.appendChild(box); }
      });
    } else {
      var term = products.length && shownFor ? shownFor : q;
      var all = el('a', 'zp-sb__all', 'See all gifts for “' + term + '”'); all.href = searchLink(term); results.appendChild(all);
    }
    idle.hidden = true; results.hidden = false; active = -1;
  }
  function fetchSuggest(q) {
    var url = suggestUrl + '?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,query&resources[limit]=6&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,variants.title,tag,vendor';
    return fetch(url, { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function count(d) { var r = (d && d.resources && d.resources.results) || {}; return (r.products || []).length; }
  function suggest() {
    var q = input.value.trim();
    clearBtn.hidden = !input.value;
    if (q.length < 2) { showIdle(); open(); return; }
    if (ctrl) ctrl.abort();
    ctrl = window.AbortController ? new AbortController() : null;
    var my = ++seq;
    loadCats(function () {});
    fetchSuggest(q).then(function (d) {
      if (my !== seq) return;
      lastFix = null;
      if (count(d)) { render(q, d); open(); return; }
      /* Nothing found: try the corrected spelling, then just the key words */
      var tries = [corrected(q), core(q)].filter(function (t, i, a) { return t && t.toLowerCase() !== q.toLowerCase() && a.indexOf(t) === i; });
      var w = core(q).split(' ');
      if (w.length > 1) tries.push(w.sort(function (a, b) { return b.length - a.length; })[0]);
      (function next(i) {
        if (i >= tries.length) { if (my === seq) { render(q, d); open(); } return; }
        fetchSuggest(tries[i]).then(function (d2) {
          if (my !== seq) return;
          if (count(d2)) { lastFix = { q: q, to: tries[i] }; render(q, d2, tries[i]); open(); } else next(i + 1);
        }).catch(function () {});
      })(0);
    }).catch(function () {});
  }
  function items() { return Array.prototype.slice.call(panel.querySelectorAll('a')).filter(function (a) { return a.offsetParent !== null; }); }

  input.addEventListener('focus', function () { if (input.value.trim().length >= 2) suggest(); else { showIdle(); open(); } });
  input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(suggest, 160); });
  input.addEventListener('keydown', function (e) {
    var list = items();
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      if (panel.hidden || !list.length) return;
      e.preventDefault();
      active = e.key === 'ArrowDown' ? Math.min(active + 1, list.length - 1) : Math.max(active - 1, -1);
      list.forEach(function (a, i) { a.setAttribute('aria-selected', i === active ? 'true' : 'false'); });
      if (active >= 0) list[active].scrollIntoView({ block: 'nearest' });
    } else if (e.key === 'Enter' && active >= 0 && list[active]) {
      e.preventDefault(); saveRecent(input.value); window.location.href = list[active].href;
    } else if (e.key === 'Escape') { close(); input.blur(); }
  });
  clearBtn.addEventListener('click', function () { input.value = ''; clearBtn.hidden = true; showIdle(); open(); input.focus(); });
  form.addEventListener('submit', function (e) {
    var q = input.value.trim();
    if (!q) { e.preventDefault(); input.focus(); return; }
    saveRecent(q);
    /* A misspelt search (no gifts found) goes straight to the words that did find gifts */
    if (lastFix && lastFix.q === q) { e.preventDefault(); window.location.href = searchLink(lastFix.to); }
  });
  panel.addEventListener('click', function (e) { var a = e.target.closest('a'); if (a && input.value.trim()) saveRecent(input.value); });
  document.addEventListener('click', function (e) { if (!root.contains(e.target)) close(); });
  clearBtn.hidden = !input.value;

  /* ---------- Voice search (Chrome on Android & desktop) ---------- */
  var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
  if (SR && micBtn) {
    micBtn.hidden = false;
    var rec = null;
    micBtn.addEventListener('click', function () {
      if (rec) { rec.stop(); return; }
      rec = new SR(); rec.lang = 'en-IN'; rec.interimResults = true; rec.maxAlternatives = 1;
      micBtn.classList.add('is-on'); input.setAttribute('placeholder', 'Listening… say “photo frame for mom”');
      rec.onresult = function (ev) {
        var t = ''; for (var i = 0; i < ev.results.length; i++) t += ev.results[i][0].transcript;
        input.value = t; clearBtn.hidden = !t;
        if (ev.results[ev.results.length - 1].isFinal) suggest();
      };
      rec.onend = rec.onerror = function () { micBtn.classList.remove('is-on'); rec = null; input.setAttribute('placeholder', 'Search gifts'); if (input.value.trim()) { suggest(); open(); } };
      try { rec.start(); } catch (e) { micBtn.classList.remove('is-on'); rec = null; }
    });
  }

  /* Never fight the menu: close the search panel when the mobile menu or a desktop dropdown opens */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d && d.id === 'Details-menu-drawer-container' && d.open) { close(); input.blur(); }
  }, true);
  document.querySelectorAll('.menu-list__list-item').forEach(function (li) {
    li.addEventListener('mouseenter', function () { if (!panel.hidden) close(); });
  });

  /* On phones, bring the search box to the top so suggestions are not hidden by the keyboard */
  function bringUp(smooth) {
    var hdr = document.querySelector('#header-component');
    var off = hdr && getComputedStyle(hdr.closest('.header-section') || hdr).position === 'sticky' ? hdr.offsetHeight : 0;
    var top = root.getBoundingClientRect().top + window.scrollY - off;
    if (Math.abs(window.scrollY - top) > 8) window.scrollTo({ top: Math.max(0, top), behavior: smooth ? 'smooth' : 'auto' });
  }
  input.addEventListener('focus', function () { if (window.innerWidth < 750) bringUp(true); });

  /* Header search icon: shown only once the bar has scrolled away; tapping it brings the bar back and opens it */
  if (window.IntersectionObserver) {
    new IntersectionObserver(function (en) {
      document.documentElement.classList.toggle('zp-sb-away', !en[0].isIntersecting);
    }).observe(root);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('#header-component .search-action, #header-component [href*="/search"]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    bringUp(false);
    input.focus({ preventScroll: true });
  }, true);

  /* Gift finder shortcut: smooth-scroll on the home page */
  var finder = root.querySelector('[data-zp-sb-finder]');
  if (finder) finder.addEventListener('click', function (e) {
    var target = document.getElementById('zp-finder');
    close(); input.blur();
    if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });

  /* Rotating search ideas in the empty box */
  var hints = (input.getAttribute('data-zp-sb-hints') || '').split('|').filter(Boolean);
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (hints.length && !reduce) {
    var hi = 0;
    setInterval(function () {
      if (document.activeElement === input || input.value || (micBtn && micBtn.classList.contains('is-on'))) return;
      hi = (hi + 1) % hints.length;
      input.setAttribute('placeholder', 'Search gifts – try “' + hints[hi] + '”');
    }, 2800);
  }
})();
